var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "mb-3" }, [
    _c("div", { staticClass: "card" }, [
      _vm._m(0),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "card-body p-0" },
        [
          [
            _c("v-data-table", {
              staticClass: "elevation-1",
              attrs: {
                "item-class": _vm.ITEM_ROW_BACKGROUND,
                headers: _vm.headers,
                loading: _vm.loading,
                items: _vm.payments,
                "hide-default-footer": "",
                dense: "",
                "items-per-page": -1,
              },
              scopedSlots: _vm._u(
                [
                  {
                    key: "item.efectivo",
                    fn: function (ref) {
                      var item = ref.item
                      return [
                        _vm._v(
                          "\n                        $ " +
                            _vm._s(Number(item.efectivo_usd || 0).toFixed(2)) +
                            " "
                        ),
                        _c("br"),
                        _vm._v(
                          " ₡ " +
                            _vm._s(Number(item.efectivo || 0).toFixed(2)) +
                            "\n                    "
                        ),
                      ]
                    },
                  },
                  {
                    key: "item.tarjeta",
                    fn: function (ref) {
                      var item = ref.item
                      return [
                        _vm._v(
                          "\n                        $ " +
                            _vm._s(Number(item.tarjeta_usd || 0).toFixed(2)) +
                            " "
                        ),
                        _c("br"),
                        _vm._v(
                          " ₡ " +
                            _vm._s(Number(item.tarjeta || 0).toFixed(2)) +
                            "\n                    "
                        ),
                      ]
                    },
                  },
                  {
                    key: "item.transferencia",
                    fn: function (ref) {
                      var item = ref.item
                      return [
                        _vm._v(
                          "\n                        $ " +
                            _vm._s(
                              Number(item.transferencia_usd || 0).toFixed(2)
                            ) +
                            " "
                        ),
                        _c("br"),
                        _vm._v(
                          " ₡ " +
                            _vm._s(Number(item.transferencia || 0).toFixed(2)) +
                            "\n                    "
                        ),
                      ]
                    },
                  },
                  {
                    key: "item.sinpe_movil",
                    fn: function (ref) {
                      var item = ref.item
                      return [
                        _vm._v(
                          "\n                        ₡ " +
                            _vm._s(Number(item.sinpe_movil || 0).toFixed(2)) +
                            "\n                    "
                        ),
                      ]
                    },
                  },
                ],
                null,
                true
              ),
            }),
          ],
        ],
        2
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "card-header bg-white" }, [
      _c("h5", { staticClass: "me-auto" }, [_vm._v("Pagos")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }